import {BASE_PATH_API, TIMEOUT_TIME, STAGE_DIRNAME, BASE_PATH_API_DEV, BASE_PATH_T1, JWT1} from 'constants/general'
import axios from 'axios'
import { decodeStorage } from 'functions/storageBase64'
import { timeNow } from'functions/timeNow'


export async function postPayPlanCards(dataRaw){
    let apiURL = `${BASE_PATH_API}/t1pagos/v2/cards/payments`
    let token = decodeStorage('access_token')
    let row = dataRaw

    const config = {
        method: 'post',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        crossdomain: true,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${token}`
        },
        data: row
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}